// The takeoff canvas toolbar "ribbon": pinned = docked above the drawing (as it always was); unpinned = a slim bar, and the
// tiles float down over the drawing while the pointer is over the bar, then fold away. A per-viewer VIEW setting
// (localStorage); the default is pinned, so nothing changes for anyone until they unpin it.

export const RIBBON_PIN_KEY = "cs.takeoff.ribbonPinned";
export const RIBBON_CLOSE_DELAY_MS = 350;   // grace period after the pointer leaves, so a slip does not fold the ribbon away

/** The viewer's own pin choice: true / false once they have clicked the pin, null while they never have (then a default applies). */
export const readRibbonPinChoice = (storage = typeof localStorage !== "undefined" ? localStorage : null) => {
  try { const v = storage?.getItem(RIBBON_PIN_KEY); return v === "1" ? true : v === "0" ? false : null; } catch { return null; }
};
/** Pinned? The viewer's choice if they made one, else `fallback` (the window-size default; pinned for the full-size layout). */
export const readRibbonPinned = (storage = typeof localStorage !== "undefined" ? localStorage : null, fallback = true) => {
  const c = readRibbonPinChoice(storage);
  return c === null ? fallback : c;
};
export const writeRibbonPinned = (pinned, storage = typeof localStorage !== "undefined" ? localStorage : null) => {
  try { storage?.setItem(RIBBON_PIN_KEY, pinned ? "1" : "0"); } catch { /* a view preference only */ }
};

/** Is the ribbon's tile area showing? Pinned always; unpinned only while it is floated (pointer over it, or focus inside it). */
export const ribbonVisible = ({ pinned, hover, focusWithin }) => !!(pinned || hover || focusWithin);
